/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep03,
    resetQuotes,
    setStep03Renewals,
    getRenewalVariation,
    getQuoteVariation
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step03m from '../components/Step03mView'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'full.response.quote', {}),
        totalExhibitsSumInsured: get(state.quote, 'full.response.quote.stockBusinessAssets.totalExhibitsSumInsured', 0),
        totalSpecifiedItem: get(state.quote, 'full.response.quote.stockBusinessAssets.totalSpecifiedItem', 0),
        exhibitsItems: get(state.quote, 'full.response.quote.stockBusinessAssets.specifiedItem', {}),
        incomingExhibitionLimit: get(state.quote, 'full.response.quote.stockBusinessAssets.incomingExhibitionLimit', 0),
        outgoingExhibitionLimit: get(state.quote, 'full.response.quote.stockBusinessAssets.outgoingExhibitionLimit', 0),
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
    }
)(Step03m)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/EditQuote/containers/Step03m.tsx